import App from 'app/app.js';

function LtRadioDirective() {
  return {
    restrict: 'E',
    scope: {
      ltId: '@', // ID to use on input field, label should have this in it's for att
      ltName: '@', // name to use on input field
      ltLabelId: '@', // ID of the label this belongs to
      ltNgValue: '=', // value for this radio
      ltNgModel: '=', // ng-model data
      ltSelected: '=' // use this if you're not using ng-model
    },
    // aria labels for accessibility https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/SVG_and_CSS
    template:
      '   <input type="radio" id="{{ltId}}" name="{{ltName}}" ng-model="ltNgModel" ng-value="ltNgValue" hidden="hidden" aria-hidden="true"/>' +
      '   <span class="lt-radio"' +
      '         ng-class="{selected: showSelected()}"' +
      '         ng-click="toggleValue()"' +
      '         ng-keypress="onKeypress($event)"' +
      '         role="radio"' +
      '         aria-checked="{{showSelected()}}"' +
      '         aria-labelledby="{{ltLabelId}}"' +
      '         tabindex="0">' +
      '       <svg xmlns="http://www.w3.org/2000/svg" height="20px" width="20px">' +
      '           <g xmlns="http://www.w3.org/2000/svg" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
      '               <g transform="translate(-152.000000, -543.000000)">' +
      '                   <g transform="translate(134.000000, 274.000000)">' +
      '                       <g transform="translate(16.000000, 174.000000)">' +
      '                           <g transform="translate(2.000000, 91.000000)">' +
      '                               <g transform="translate(0.000000, 4.000000)">' +
      '                                   <circle class="Background" fill="#FFFFFF" cx="8.5" cy="8.5" r="8.5"/>' +
      '                                   <path d="M8.5,16 C12.6421356,16 16,12.6421356 16,8.5 C16,4.35786438 12.6421356,1 8.5,1 C4.35786438,1 1,4.35786438 1,8.5 C1,12.6421356 4.35786438,16 8.5,16 Z M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"' +
      '                                         class="Border"' +
      '                                         fill-rule="nonzero"/>' +
      '                                   <circle class="Selected" role="presentation" cx="8.5" cy="8.5" r="5.5"/>' +
      '                             </g>' +
      '                         </g>' +
      '                      </g>' +
      '                  </g>' +
      '              </g>' +
      '            </g>' +
      '       </svg>' +
      '   </span>',
    link: function (scope) {
      scope.toggleValue = function () {
        scope.ltNgModel = scope.ltNgValue;
      };

      scope.onKeypress = function (event) {
        if (event.key === ' ') {
          // if space key was hit
          scope.toggleValue();
        }
      };

      scope.showSelected = function () {
        return !!scope.ltNgModel ? scope.ltNgModel === scope.ltNgValue : scope.ltSelected;
      };
    }
  };
}

App.directive('ltRadio', LtRadioDirective);
